import Lottie from 'lottie-react';
import {ReactNode} from 'react';
import styled from 'styled-components';
import {CheckIconComponent} from '@/components/Icons';
import {FlexFullGrow} from '@/styled-components';
import {palette} from '@/styles';
import CopyLottie from './assets/copy-lottie.json';
import {AiIcon, CircleIconButton} from './StyledComponents';

interface IProps {
  children?: ReactNode;
  isCopied?: boolean;
  onCopyClick?(): void;
}

export const AiSubHeader = ({children, isCopied, onCopyClick}: IProps) => {
  return (
    <Root>
      <AiIcon />
      {children}
      <FlexFullGrow />
      {isCopied ? (
        <CopyButton disabled={true}>
          복사됨
          <CheckIconComponent color={palette.teal100} />
        </CopyButton>
      ) : (
        !!onCopyClick && (
          <CopyButton onClick={onCopyClick}>
            복사
            <CircleIconButton as="div">
              <Lottie
                loop={1}
                animationData={CopyLottie}
                style={{width: 20, height: 20}}
              />
            </CircleIconButton>
          </CopyButton>
        )
      )}
    </Root>
  );
};

const Root = styled.div`
  display: flex;
  padding: 12px 16px 4px;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 400;
  color: ${palette.gray400};
  line-height: 1.5;
  letter-spacing: -0.36px;
  flex-shrink: 0;
`;

const CopyButton = styled.button`
  flex-shrink: 0;
  color: ${palette.gray600};
  display: flex;
  align-items: center;
  gap: 2px;
  cursor: pointer;
  &:disabled {
    cursor: default;
  }
`;
